<template>
    <div>
        <PageHeader :page="page" :template="'2'" @action="createNew" v-if="!state.loading"/>
        <div class="" v-if="!state.loading">
            <DataTable :tableData="tableData" @edit="edit" />
        </div>
        <div class="temp-row" v-if="state.loading" style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </div>
    <ModalView
        :isVisible="state.CreateModal"
        :fixclose="true"
        @close="state.CreateModal = false">
        
        <DynamicForm :columns="1"
            :fields="newFields" @submit="addPackage"
            :submitting="state.submitting" :errors="state.errors"
            :success="state.success" />
    </ModalView> 

    <ModalView
        :isVisible="state.editModal"
        :fixclose="true"
        @close="state.editModal = false">
        
        <div v-if="!state.modalLoading">
            <DynamicForm :columns="1"
                :fields="editFields" @submit="editSubPackage"
                :submitting="state.submitting" :errors="state.errors"
                :success="state.success" />
        </div>
        <div v-else style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
          </div>
    </ModalView> 
</template>
<script>
import icons from '@/assets/js/icons.js';
import { defineComponent,ref,reactive,onMounted, computed} from 'vue';
import { useStore } from 'vuex';
import PageHeader from '@/components/PageHeader.vue';
import DataTable from '@/components/DataTable.vue';
import DynamicForm from '@/components/DynamicForm.vue';
import ModalView from '@/components/ModalView.vue';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { usePermissions } from '@/composables/usePermissions';
export default defineComponent({
    components:{PageHeader,DataTable,DynamicForm,ModalView},
    setup(){
        const store= useStore();
        const system = computed(() => store.state.System.system);
        const editFields=ref([])
        const { hasPermission } = usePermissions();
        const page=ref({title:"Subscription Package", btn:"Add new",
            desc:"Manage your subscription database with ease"})
        const state=reactive({loading:true,CreateModal:false,modalLoading:false,editModal:false})
        var action_label=[],
        action=[]
        if(!hasPermission('Subscription Admin', 'create')){
            page.value.btn="";
        }
        if(hasPermission('Subscription Admin', 'edit')){
            action.push("edit");
            action_label.push(icons.edit)
        }
        const tableData = ref({
            rows: [],
            loading: true,
            columns: [
                { label: "Name" },
                { label: "Duration" },
                { label: "Price" }
            ],
            options:{
                label:"Action",
                action_label:action_label,
                action:action
            },
            total:0
        });
        

        function createNew(){
            if(system.value.acct_type==""){
                alert("Office accounting settings not found. Please contact your system administrator to configure accounting settings to continue")
            }else{
                state.success=false;
                state.error=[]
                state.CreateModal=true;
            }
        }

        var duration=[],i=1;
        for(i; i < 49; i++){
            var d=i ==1 ? i+" Month" : i+" Months";
            duration.push({label:d, value:i});
        }

        const newFields=ref([
            { name: "Add Package", number: "1",data: 
                [{ type: 'text', name: 'name', label: 'Name',
                value: ""  },
                { type: 'text', name: 'price', label: 'Price',
                value: "" },
                {type: 'select', name: 'duration', label: 'Duration',
                value: "", options:duration},
                {type: 'textarea', name: 's_desc', label: 'Description',
                value: ""}
                ]
            }
        ])

        function addPackage(data){
            state.submitting=true;
            state.errors=[];
            data.addSubPackage="";
            call({
                url:urls.customer,
                data:data,
                success:(res)=>{
                    state.submitting=false;
                    if(res.status){
                        state.success=true;
                        setTable(res.msg);
                    }else{
                        setErrors(res)
                    }
                }
            })
        }

        onMounted(() => {
            call({
                url:urls.customer,
                data:{startSubPackages:""},
                success:(res)=>{
                state.loading=false
                if(res.status){
                    var d=res.msg;
                    setTable(d.packages);
                }else{
                    alert(res.msg);
                }
                }
            })
        });

        

        function setErrors(res){
            var errors=[];
            Object.keys(res.msg).forEach(key => {
            var e=res.msg[key],er="";
            Object.keys(e).forEach(k => {
                er+=er=="" ? e[k] : ", "+e[k]
            })
            errors.push(er);
            });
            state.errors=errors;
        }

        function setTable(msg){
            var data={}
            tableData.value.loading = false;
            tableData.value.rows.length=0
            Object.keys(msg).forEach(set => {
                data={id:msg[set].id,status:msg[set].status};
                var v=[];
                Object.keys(msg[set].val).forEach(row => {
                v.push(msg[set].val[row])
                });
                data.val=v;
                tableData.value.rows.push(data)
            });
            tableData.value.total=tableData.value.rows.length
        }

        function edit(i){
            state.modalLoading=true
            state.editModal=true;
            state.success=false;
            state.submitting=false;
            state.errors=[];
            var id=tableData.value.rows[i].id
            call({
                url:urls.customer,
                data:{getSubPackage:id},
                success:(res)=>{
                    state.modalLoading=false;
                    if(res.status){
                        editFields.value.length=0;
                        var p=res.msg.package;
                        editFields.value.push(
                            { name: "Package Info", number: "1",data: 
                                [{ type: 'text', label: 'Name',name: 'name',
                                value: p.name  },
                                {type: 'text',label: 'Price',name: 'price',
                                value: p.price},
                                { type: 'select', label: 'Duration',name: 'duration',
                                value: p.duration,options:duration },
                                { type: 'textarea', label: 'Description',name: 's_desc',
                                value: p.desc},
                                {type:"hidden", value:id, name:"id"}
                                ]
                            }
                        );
                    }else{
                        setErrors(res)
                    }
                }
            })
        }

        function editSubPackage(data){
            state.submitting=true;
            state.errors=[];
            data.editSubPackage="";
            call({
                url:urls.customer,
                data:data,
                success:(res)=>{
                state.submitting=false;
                if(res.status){
                    state.success=true;
                    setTable(res.msg);
                }else{
                    setErrors(res)
                }
                }
            })
        }

        return{page, state,tableData,createNew,newFields,addPackage, edit,editFields,
            editSubPackage
        }
    }
})
</script>
